<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot=primary>
      <ion-button (click)="modalController.dismiss()"> {{ 'core.done' | translate }} </ion-button>
    </ion-buttons>
    <ion-title>{{ rooms.length > 0 ? rooms[0].room.building.name : ('study-areas.studySpaces.selectLocation.availableRooms' | translate) }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="light">
    <ion-list [inset]="true">
      <ion-list-header mode="ios">
        <ion-label>{{ 'study-areas.studySpaces.selectLocation.availableRooms' | translate }}</ion-label>
      </ion-list-header>
      @if (rooms.length === 0) {
        <ion-item lines="none">
          <ion-note mode="ios">
            {{ 'study-areas.studySpaces.selectLocation.noRooms' | translate }}
          </ion-note>
        </ion-item>
      }
      @for (metaRoom of rooms; track $index) {
        <ion-item [button]="true" [lines]="rooms.length === 1 ? 'none' : 'inset'" (click)="openTimetable(buildingId, metaRoom.room.id)">
          <ion-icon aria-hidden="true" [color]="metaRoom.currentlyBlocked ? 'warning' : 'primary'" name="time" slot="start"></ion-icon>
          <ion-label class="flex flex-column">
            {{ metaRoom.room?.roomNo }}
          </ion-label>
          <ion-note color="secondary" class="ion-text-wrap">
            {{ metaRoom?.currentAppointment?.end | humanizedDate }}
          </ion-note>
        </ion-item>
      }
    </ion-list>
</ion-content>
